// extracted by mini-css-extract-plugin
module.exports = {"Bubble":"index-module--Bubble--20xlf","top":"index-module--top--NmEhm","bottom":"index-module--bottom--1ewiZ"};